import axios, { AxiosRequestConfig, InternalAxiosRequestConfig } from "axios";
import React, { createContext } from "react";
import { AuthorizationInterceptor } from '../middleware/AuthorizationInterceptor';
import { AuthenticationInterceptor } from "../middleware/AuthenticationInterceptor";
import ServiceApi from "../model/ServiceApi.model";
import ConfigService from '../config/config.service';
import { SessionInterceptorRejected } from '../middleware/SessionInterceptor';
import _ from 'lodash';
import { IComponentFormProps } from "../interface/generic-form/IComponentFormProps";

export const ServiceContext = createContext<ServiceApi>(null);

export const ServiceProvider: React.FC<IComponentFormProps> = ({ children, history }) => {
  const baseURL = ConfigService.getConfig().apiUrl;
  const restClient = axios.create({ baseURL });
  const throttledPush = _.throttle((path: string) => history.push(path), 10000);

  restClient.interceptors.response.use(res => res, SessionInterceptorRejected(history.location, throttledPush));

  restClient.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
    const updatedConfig = await AuthenticationInterceptor(config as AxiosRequestConfig);
    return updatedConfig as InternalAxiosRequestConfig;
  });

  restClient.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
    const updatedConfig = await AuthorizationInterceptor(history)(config as AxiosRequestConfig);
    return updatedConfig as InternalAxiosRequestConfig;
  });

  const apis = new ServiceApi(restClient);
  return <ServiceContext.Provider value={apis}>{children}</ServiceContext.Provider>;
};
